/** @jsxImportSource @emotion/react */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomDialog from 'components/modals/common/CustomDialog';
import CustomGrid from '../../../components/grids/CustomGrid';
import { findMpEquipmentHistory } from '../../../apis/mp/MpEquipment';
import { MpEquipmentHistory } from '../../../models/mp/MpEquipment';
import { useMessageBar } from '../../../hooks/useMessageBar';

interface Props {
  open: boolean;
  close: (isDone?: boolean) => void;
  title: string;
  condition?: {
    mpItemId?: string;
    horExplYn?: string;
    prdnPlntCd?: string; //수평전개는 공장별 설비이력
  };
}

/**
 * mp 대상 설비 이력 조회 팝업
 * @param open
 * @param close
 * @param condition
 * @constructor
 */
export const MpEquipmentHistoryPopUp = ({ open, close, title, condition }: Props) => {
  const { t } = useTranslation();
  const { openMessageBar } = useMessageBar();

  const [rowData, setRowData] = useState<MpEquipmentHistory[]>([]);

  // search
  useEffect(() => {
    findMpEquipmentHistory(condition).then((result) => {
      if (result !== null) {
        setRowData(result);
      } else {
        openMessageBar({
          type: 'error',
          content: t(
            'com.msg.요청 정보 조회 중 오류가 발생했습니다.',
            '요청 정보 조회 중 오류가 발생했습니다.'
          ),
        });
        return false;
      }
    });
  }, [condition]);

  const onInitialized = (grid) => {
    console.log('onInitialized... ');
  };

  //FactoryId, Factory명, 설비ID, 설비명, 설비레벨, 사용여부, 변경사유, 수정자, 최종수정일
  const layoutDefinition = [
    {
      header: String(t('com.label.Factory ID', 'Factory ID')),
      binding: 'prdnPlntCd',
      width: 80,
    },
    {
      header: String(t('com.label.Factory 명', 'Factory 명')),
      binding: 'prdnPlntNm',
      align: 'left',
    },
    {
      header: String(t('com.label.설비ID', '설비ID')),
      binding: 'equipmentId',
      width: 100,
    },
    {
      header: String(t('com.label.설비명', '설비명')),
      binding: 'equipmentName',
      align: 'left',
      width: 160,
    },
    {
      header: String(t('com.label.설비레벨', '설비레벨')),
      binding: 'equipmentLevel',
      width: 80,
    },
    {
      header: String(t('com.label.삭제', '삭제')),
      binding: 'useYn',
      width: 80,
      cellTemplate: (params) => (params.value === 'N' ? '삭제' : ''),
    },
    {
      header: String(t('com.label.변경사유', '변경사유')),
      binding: 'chgRsnCtn',
      align: 'left',
      width: '*',
    },
    {
      header: String(t('com.label.수정자', '수정자')),
      binding: 'dataUpdUserNm',
      width: 80,
    },
    {
      header: String(t('com.label.최종수정일', '최종수정일')),
      binding: 'dataUpdDtm',
      width: 100,
    },
  ];

  return (
    <>
      <CustomDialog title={title} open={open} onClose={close} onCancel={close}>
        <CustomGrid
          layoutDefinition={layoutDefinition}
          rowData={rowData}
          height={300}
          align={'center'}
          allowPinning={false}
          isFilter={false}
          isReadOnly={true}
          isSelector={false}
          initialized={onInitialized}
        />
      </CustomDialog>
    </>
  );
};
